/**
 * Determine whether a customer visit should be logged based on the stored next-visit timestamp.
 *
 * @returns {boolean} True if a visit should be logged.
 */
function shouldLogVisit() {
    const nextVisitLogTime = localStorage.getItem("next_visit_log");
    if (!nextVisitLogTime) {
        return true;
    }

    const nextVisitLog = new Date(Number(nextVisitLogTime));
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    return now >= nextVisitLog;
}

/**
 * Send a POST request to record the current customer visit and update the next-visit timestamp.
 *
 * @returns {void}
 */
function recordVisit() {
    fetch("/tracking/log_customer_visit", {
        method: "POST",
        headers: {
            "X-CSRF-TOKEN": window.CSRF_TOKEN,
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            if (response.status === 200 || response.status === 201) {
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                tomorrow.setHours(0, 0, 0, 0);

                localStorage.setItem(
                    "next_visit_log",
                    tomorrow.getTime().toString(),
                );
            }
        })
        .catch((error) => {
            console.error("Error logging visit:", error);
        });
}

if (shouldLogVisit()) {
    recordVisit();
}

export {};
